import React from 'react'
import Childimg from '../assets/images/childimg.png'
import Chatimg from '../assets/images/chat.png'
import Education from '../assets/images/education.png'
import Diversity from '../assets/images/diversity.png'
import Influsion from '../assets/images/inclusion.png'
import Backet from '../assets/images/bucketimg.png'
import Education1 from '../assets/images/education1.png'
import Inclusion1 from '../assets/images/inclusion1.png'
import Scholarship from '../assets/images/scholarship.png'
import Diversity1 from '../assets/images/diversity1.png'

const MitaoBhook = () => {
  return (
    <div>
      <div className='mt-16 w-full'>
        <img src={Childimg} alt="Child" className='w-full' />
      </div>
      <div className='flex items-center justify-center mt-16'>
        <img src={Chatimg} alt="Chat" className='w-[70%]' />
      </div>
      <div className='flex items-center justify-center'>
        <h2 className="md:text-xl lg:text-3xl mb-70 mx-auto text-center font-bold">
          MITAO BHOOK FOCUSES ON THREE KEY PILLARS TO CREATE SUSTAINABLE <br />
          POSITIVE ECOSYSTEM IN <span className="text-green-500">PAKISTAN</span>
        </h2>
      </div>
      <div className='flex items-center justify-center mt-16 space-x-6'>
        <img src={Education} alt='education' />
        <img src={Diversity} alt='diversity' />
        <img src={Influsion} alt='Influsion' />
      </div>
      <div className='items-center justify-center'>
        <img src={Backet} alt='backet' className='w-[100%]' />
        <h2 className="md:text-xl lg:text-2xl mx-auto text-center font-bold">
          KFC DONATES RS 50 FROM THE SALES OF EVERY VALUE BUCKET TO MITAO BHOOKAND HAS SPENT OVER <span className='text-dark-secondary'>$2 MILLION</span> TOWARDS SOCIAL EFFROTS IN THE COUNTRY TOGETHER, WE’RE CREATING</h2>
      </div>
      <div className='items-center justify-center bg-white text-lg p-[50px] mt-9'>
        <h1 className='text-center font-bold'>
          TOGETHER, WE’RE CREATING IMPACT AND CHANGING LIVES
        </h1>
      </div>
      <div className='min-h-[70vh] md:container md:mx-auto flex items-center justify-center space-x-4'>
        <div className='flex items-center p-4'>
          <img src={Education1} alt='education 1' />
        </div>
        <div className=' items-center w-[50%] justify-end p-4'>
          <h1 className='text-5xl font-bold p-4'>Education</h1>
          <h5 className='text-start text-xl p-4'>EDUCATING <span className='text-dark-secondary'>5000+ STUDENTS</span> ACROSS PAKISTAN</h5>
        </div>
      </div>
      <div className='min-h-[70vh] md:container md:mx-auto flex items-center justify-center space-x-4'>
        <div className=' items-center w-[50%] justify-end p-4'>
          <h1 className='text-5xl font-bold p-4'>Education</h1>
          <h5 className='text-start text-xl p-4'>EDUCATING <span className='text-dark-secondary'>5000+ STUDENTS</span> ACROSS PAKISTAN</h5>
        </div>
        <div className='flex items-center p-4'>
          <img src={Inclusion1} alt='education 1' />
        </div>
      </div>
      <div className='min-h-[70vh] md:container md:mx-auto flex items-center justify-center space-x-4'>
        <div className='flex items-center p-4'>
          <img src={Diversity1} alt='education 1' />
        </div>
        <div className='items-center w-[50%] justify-end p-4'>
          <h1 className='text-5xl font-bold p-4'>Education</h1>
          <h5 className='text-start text-xl p-4'>EDUCATING <span className='text-dark-secondary'>5000+ STUDENTS</span> ACROSS PAKISTAN</h5>
        </div>
      </div>
      <div className='flex items-center bg-cover bg-no-repeat p-9' style={{ backgroundImage: `url(${Scholarship})` }}>
        <div className='text-center text-white p-8'>
          <h2 className='text-2xl font-bold mb-4'>KFC SCORE A SCHOLARSHIP PROGRAM READY TO FULFILL YOUR EDUCATION DREAMS!</h2>
          <h5>KFC Pakistan’s Mitao Bhook Platform is providing 120+ higher education scholarships to deserving students across all HEC recognized institutes in Pakistan. This is done in collaboration with The Orange Tree foundation, an education advocate working to further education in the country. Higher education gives you, the Pakistani youth, an opportunity to succeed in today’s global economy, and KFC Pakistan is excited to enable the dreams of hundreds of Pakistani scholars embarking on this journey.</h5>
        </div>
      </div>
      <div className='text-center p-9'>
        <h2>Higher education gives you, the Pakistani Youth, an opportunity to succeed in today’s global economy and KFC Pakistan is excited to enable the dreams of hundreds of Pakistani scholars embarking on this journey.
        </h2>
      </div>
    </div>
  )
}

export default MitaoBhook